import React, {useState, useRef, useEffect} from 'react';
import styles from './BubbleTipFree.module.css';
import {FontIcon} from "@/app/_components";

interface BubbleTipFreeProps {
    text1?: string;
    text2?: string;
}

const BubbleTipFree: React.FC<BubbleTipFreeProps> = ({text1, text2}) => {
    const [isVisible, setIsVisible] = useState(false);
    const bubbleRef = useRef<HTMLDivElement | null>(null);

    // 点击外部区域关闭提示框
    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
            if (bubbleRef.current && !bubbleRef.current.contains(event.target as Node)) {
                setIsVisible(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, []);

    return (
        <div className={styles.container}>
            <button
                className={styles.btn}
                type={'button'}
                onClick={(e) => {
                    e.stopPropagation();
                    setIsVisible(!isVisible);
                }}
            >
                <FontIcon icon={'s-sigh'}style={{color: '#3e1856', fontSize: '0.5rem'}}/>
            </button>
            {isVisible && (
                <div className={styles.tip} ref={bubbleRef}>
                    <div className={styles.arrow_left}/>
                    <div className={styles.content}>
                        <p>{text1}</p>
                        {text2 && <p>{text2}</p>}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BubbleTipFree;
